import { Component, OnInit } from '@angular/core';
import { PlatillosService } from '../../../services/platillos.service';
import { CategoriasService } from '../../../services/categorias.service';

import { FormBuilder, Validators } from '@angular/forms';

import { map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { GalleryService } from '../../../services/gallery.service';

@Component({
  selector: 'app-platillos',
  templateUrl: './platillos.component.html',
  styleUrls: ['./platillos.component.css']
})
export class PlatillosComponent implements OnInit {

  ds_platillos;
  ds_categorias;
  
  forma;
  image;
  slCategoria = 0;

  formulario;
  modo;

  constructor(
    public fb: FormBuilder,
    private _categoria: CategoriasService,
    private _platillos: PlatillosService,
    private _gallery: GalleryService
  ) { }

  test(){
    let control = (<HTMLInputElement>document.getElementById("ctrlSelectCategoria")).value;
    console.log("control", control)
  }

  ngOnInit(): void {
    this.formulario = false; // Vista inicial

    this.forma = this.fb.group({
      uid: this.fb.control(""),
      url: this.fb.control("assets/images/platillos/noimage.png"),
      filename: this.fb.control("noimage.png"),
      sizes: this.fb.control(null),
      title: this.fb.control("",[Validators.required]),
      description: this.fb.control(""),
      price: this.fb.control(0,[Validators.required, Validators.min(1)]),
      category: this.fb.control(null, [Validators.required])
    });

    this.image = this.forma.get('url').value;

    this.consultarPlatillos();
    this.consultarCategorias();
  }

  selectCategoria(event){

    this.slCategoria = event.target.value;

    let categoria = this.ds_categorias.find( cat => cat.uid == event.target.value );
    
    this.forma.get('category').setValue(categoria); 
    if(!categoria){
      console.log("Sin Categoria")
    }
      
  }

  consultarPlatillos(){
    this._platillos.getAll().snapshotChanges().pipe(
      map( changes =>
        changes.map( d =>
          ({ uid: d.payload.doc.id, ...d.payload.doc.data() })
        )
      )
    ).subscribe( platillos => {
      this.ds_platillos = platillos;
    })
  }

  consultarCategorias(){
    this._categoria.getAll().snapshotChanges().pipe(
      map( changes =>
        changes.map( d =>
          ({ uid: d.payload.doc.id, ...d.payload.doc.data() })
        )
      )
    ).subscribe( (categoria:any) => {
      this.ds_categorias = categoria;
      this.slCategoria = 0;
    })
  }

  guardar(){

    if(!this.forma.valid){
      Swal.fire(
        'Formulario Incompleto',
        'Es necesario un título, precio y categoría como mínimo.',
        'error'
      )
      return;
    }

    try {

      switch(this.modo) {
        case "nuevo":
            this._platillos.nuevo(this.forma.value);
          break;
        case "editar":
            this._platillos.edit(this.forma.value, this.forma.get('uid').value);
          break;
        default:
            console.log("Error en modo de formulario", this.modo);
          break;
      }

      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Platillo Guardado',
        showConfirmButton: false,
        timer: 1500
      })
      this.reset();
    } catch (error) {
      console.log({error})
    }

  }

  reset(){
    this.formulario = false;
    this.forma.reset();
    this.modo = null;

    this.forma.get('uid').setValue('');
    this.forma.get('url').setValue('assets/images/platillos/noimage.png');
    this.image = "assets/images/platillos/noimage.png";

    this.forma.get('title').setValue('');
    this.forma.get('description').setValue('');
    this.forma.get('price').setValue(0);
    this.forma.get('category').setValue(null);
    this.slCategoria = 0;
  }

  async cargaFormulario(obj){
    this.forma.get('uid').setValue(obj.uid);
    this.forma.get('url').setValue(obj.url);
    this.forma.get('filename').setValue(obj.filename);
    this.forma.get('title').setValue(obj.title);
    this.forma.get('description').setValue(obj.description);
    this.forma.get('price').setValue(obj.price);
    this.forma.get('sizes').setValue(obj.sizes);
    this.forma.get('category').setValue(obj.category);
    this.slCategoria = obj.category.uid;

    this.image = await this._gallery.imageExist(this.forma.get('filename').value, 'assets/images/platillos/noimage.png');

    (<HTMLInputElement>document.getElementById("ctrlSelectCategoria")).value = obj.category.uid;
  }

  nuevo(){
    this.reset();
    this.formulario = true;
    this.modo = "nuevo";
    window.scroll({
      top: 300,
      left: 300,
      behavior: 'smooth'
    });
  }
  
  editar(obj){
    this.reset();
    this.formulario = true;
    this.modo = "editar";
    this.cargaFormulario(obj);

    window.scroll({
      top: 300,
      left: 300,
      behavior: 'smooth'
    });
  }

  eliminar(obj){
    this.reset();
    this.formulario = false;
    Swal.fire({
      title: 'Eliminar Categoría',
      html: "¿Quieres eliminar el platillo <strong>"+ obj.title + "</strong>?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#009045',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {

        try {
          // Eliminar 

          this._platillos.delete(obj.uid);

          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Platillo Eliminado',
            showConfirmButton: false,
            timer: 1500
          })
          
        } catch (error) {
          console.log({error})
        }

      }
    })
  }

  // Recibe imagen seleccionada
  getImageData(event){
    this.forma.get('url').setValue(event.url);
    this.forma.get('filename').setValue(event.filename);

    let sizesUrl = [];
    // Obtener URLS segun tamaño:
    event.sizes.forEach( async data => {
        let urlSize = await this._gallery.imageExist( data.name, 'assets/images/platillos/noimage.png')
        sizesUrl.push( { size: data.size, url: urlSize } )
    })
    this.forma.get('sizes').setValue(sizesUrl);
    this.image = event.url;
  }

  cancelar(){
    this.reset();
    this.formulario = false;
  }

/*   getNameCategory(uid: string){
    try{
      return this.ds_categorias.find( (res:any) => res?.uid == uid)['categoria'];
    }catch(error){
      return error;
    }
  } */

}
